import { travel } from 'api';

import { CancellationPoliciesRequest, CancellationPoliciesResponse } from 'models/cancellationPolicies';

interface Response {
  data: CancellationPoliciesResponse;
}

export const fetchCancellationPolicies = (data: CancellationPoliciesRequest) =>
  travel.post<Response>('/Hotel/HotelValidation', { ...data });
